import ApiService from "../api";

export default class TipoServicoTIService extends ApiService {

    constructor() {
        super('/api/solicitacoes/chamados-ti/tipos-servico')
    }

    listar() {
        return this.get(``);
    }

    salvar(dto) {
        return this.post(``, dto);
    }

    atualizar(id, dto) {
        return this.put(`/${id}`, dto);
    }

    excluir(id) {
        return this.delete(`/${id}`);
    }
}
